var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7074 0.293031C13.8949 0.480558 14.0002 0.734866 14.0002 1.00003C14.0002 1.26519 13.8949 1.5195 13.7074 1.70703L5.70741 9.70703C5.51988 9.8945 5.26557 9.99982 5.00041 9.99982C4.73524 9.99982 4.48094 9.8945 4.29341 9.70703L0.293407 5.70703C0.111249 5.51843 0.0104547 5.26583 0.0127331 5.00363C0.0150115 4.74143 0.12018 4.49062 0.305589 4.30521C0.490997 4.1198 0.741809 4.01464 1.00401 4.01236C1.2662 4.01008 1.5188 4.11087 1.70741 4.29303L5.00041 7.58603L12.2934 0.293031C12.4809 0.10556 12.7352 0.000244141 13.0004 0.000244141C13.2656 0.000244141 13.5199 0.10556 13.7074 0.293031Z",
    fill: "url(#paint0_linear_366_191)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_366_191",
    x1: 5.16095,
    y1: 2.51738,
    x2: 13.0605,
    y2: 15.5834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.d46ac5d179b27f7800e1abd9da568847.svg";
export { ForwardRef as ReactComponent };